var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCareLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CFE7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9979 36.506L21.499 34.0049L18.9979 31.5039",
    stroke: "#0A5190",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9958 34.0042H21.499",
    stroke: "#0A5190",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9291 29.0024C11.7959 24.7087 12.6182 19.5349 15.9774 16.1141C19.3367 12.6933 24.4947 11.7773 28.8264 13.8322C33.1581 15.8871 35.7116 20.4615 35.1872 25.2271C34.6629 29.9928 31.1759 33.9025 26.5011 34.9665",
    stroke: "#0A5190",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6895 23.0621C28.6895 22.5441 28.2695 22.1242 27.7516 22.1242H25.8758V20.2484C25.8758 19.7305 25.4559 19.3105 24.9379 19.3105H23.0621C22.5441 19.3105 22.1242 19.7305 22.1242 20.2484V22.1242H20.2484C19.7305 22.1242 19.3105 22.5441 19.3105 23.0621V24.9379C19.3105 25.4559 19.7305 25.8758 20.2484 25.8758H22.1242V27.7516C22.1242 28.2695 22.5441 28.6895 23.0621 28.6895H24.9379C25.4559 28.6895 25.8758 28.2695 25.8758 27.7516V25.8758H27.7516C28.2695 25.8758 28.6895 25.4559 28.6895 24.9379V23.0621Z",
    stroke: "#0A5190",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareLine);
export default __webpack_public_path__ + "static/media/careLine.58fc2a5c024858f7e922f83749aaadb4.svg";
export { ForwardRef as ReactComponent };